import { useState } from 'react'
import { dynamicGa4DataLayerPush } from '@which/shared'

import { LaptopHelperButton } from './Button/LaptopHelperButton'
import {
  setLaunchLaptopHelperDismissed,
  useLaunchLaptopHelperDismissed,
} from './dismissLaunchLaptopHelperCookie'
import { useLaptopHelperItemSpec } from './hooks/useLaptopHelperItemSpec'
import { useShouldShowLaptopHelper } from './hooks/useShouldShowLaptopHelper'
import { LaptopHelperNavigation } from './Navigation/LaptopHelperNavigation'

export const LaptopHelper = () => {
  const shouldShowLaptopHelper = useShouldShowLaptopHelper()
  const itemSpec = useLaptopHelperItemSpec()
  const launchLaptopHelperDismissedFromCookie = useLaunchLaptopHelperDismissed()
  const [laptopHelperOpen, setLaptopHelperOpen] = useState(false)
  const [launchLaptopHelperDismissed, setLaunchLaptopHelperDismissedState] = useState(
    launchLaptopHelperDismissedFromCookie
  )

  const handleOpenLaptopHelper = () => {
    setLaptopHelperOpen(true)
  }

  const handleLaptopHelperClose = () => {
    dynamicGa4DataLayerPush({
      event: 'personalisation_tool_onward_journey',
      item_text: 'close',
      item_index: 1,
      action_group: 'onward_journey',
      item_parent_text: undefined,
      item_spec: itemSpec,
      item_url: undefined,
      item_group: 'personalisation tools',
      tool_name: 'Laptop picker helper',
      item_personalisation: 'false',
    })

    setLaptopHelperOpen(false)
  }

  const handleLaunchLaptopHelperDismiss = () => {
    setLaunchLaptopHelperDismissed()
    setLaunchLaptopHelperDismissedState(true)
  }

  if (!shouldShowLaptopHelper || launchLaptopHelperDismissed) {
    return null
  }

  return laptopHelperOpen ? (
    <LaptopHelperNavigation handleClose={handleLaptopHelperClose} />
  ) : (
    <LaptopHelperButton
      onClick={handleOpenLaptopHelper}
      onDismiss={handleLaunchLaptopHelperDismiss}
    />
  )
}
